import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

const AssessmentsTable = ({ data, adminInfo }) => {
  const navigate = useNavigate();

  const handleEdit = (id) => {
    navigate(`/UpdateAssessment/${id}`);
  };

  const handleDelete = (id) => {
    // Implement the delete logic here
    console.log(`Delete assessment with id: ${id}`);
  };

  const handleCreateAssessment = () => {
    navigate('/createAssessment');
  };

  return (
    <>
  <Tooltip id="my-tooltip" />
    <div className="bg-white rounded-2xl shadow-xl border border-slate-200/50 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl-md">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-slate-900 font-bold tracking-tight">Assessments                            <a data-tooltip-id="my-tooltip" data-tooltip-content="Enter a title for the assessment." data-tooltip-place="top"> <FontAwesomeIcon icon={faInfoCircle} /> </a>
        </h3>
        <button
          className="bg-blue-500 text-white font-bold py-2 px-4 rounded"
          onClick={handleCreateAssessment}
        >
          Create Assessment
        </button>
      </div>
      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">Title</th>
            <th className="py-2 px-4 border-b">Description</th>
            <th className="py-2 px-4 border-b">Display Name</th>
            <th className="py-2 px-4 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((assessment) => (
            <tr key={assessment.id}>
              <td className="py-2 px-4 border-b">{assessment.title}</td>
              <td className="py-2 px-4 border-b">{assessment.description}</td>
              <td className="py-2 px-4 border-b">{assessment.displayName}</td>
              <td className="py-2 px-4 border-b">
                {assessment.target === adminInfo.tenantId? (
                  <>
                    <button
                      className="bg-green-500 text-white font-bold py-1 px-3 rounded mr-2"
                      onClick={() => handleEdit(assessment.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="bg-red-500 text-white font-bold py-1 px-3 rounded"
                      onClick={() => handleDelete(assessment.id)}
                    >
                      Delete
                    </button>
                  </>
                ):""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div></>
  );
};

AssessmentsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
    })
  ).isRequired,
  adminInfo: PropTypes.shape({
    tenantId: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    canUpdateCompany: PropTypes.bool.isRequired,
    canCreateAssessment: PropTypes.bool.isRequired,
  }).isRequired,
};
export default AssessmentsTable;
